module.exports = __webpack_public_path__ + "img/sfx.18435836.png";